<div class="modal fade" data-backdrop="static" tabindex="-1" id="userPreferenceSetting" role="dialog">
    <div class="modal-dialog modal-md">
        <div class="modal-content" style="height: auto;">
            <div class="modal-header content-header">
                <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close"
                    (click)="closePopup()"><i class="fa fa-close fa-md"></i></button>
                <h4 class="modal-title">User Preference Setting
                    <span *ngIf="loader" class="fa fa-spin fa-spinner"></span>
                </h4>
            </div>
            <div class="modal-body">
                <div class="card-layout card-body pt-0 mb-3">
                    <div class="row py-2 mb-2" style="background-color:#a82b41; color:white; font-weight:900;">
                        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">User Settings</div>
                        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-0 optionClass">Options</div>
                    </div>
                    <div class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Service Type</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7 [placeholder]="'Service Type'"
                                    [settings]="dropdownSettings" [data]="serviceTypes"
                                    [(ngModel)]="memberPreferenceSettings.serviceType">
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Status</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <div class="select-box" *ngIf="statusList.length >0">
                                <ng-multiselect-dropdown-angular7 [placeholder]="'Status'"
                                    [settings]="statusDropdownSettings" [data]="statusList"
                                    [(ngModel)]="memberPreferenceSettings.status">
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2" *ngIf="user.role == roleName.ExecutiveAdmin||user.role==roleName.Coordinator||
                    user.role==roleName.Accounting || user.role==roleName.Management">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Customer</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7 [placeholder]="'Customer'"
                                    [settings]="customerListSetting" [data]="customerList"
                                    [(ngModel)]="memberPreferenceSettings.customer">
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Region</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7 [placeholder]="'Region'"
                                    [settings]="regionDropdownSettings" [data]="regionList"
                                    [(ngModel)]="memberPreferenceSettings.region">
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2" *ngIf="user.role == roleName.Accounting">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Finance Status</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7 [placeholder]="'Finance Status'"
                                    [settings]="financialStatusSetting" [data]="financialStatusList"
                                    [(ngModel)]="memberPreferenceSettings.financeStatus">
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2"
                        *ngIf="user.role != roleName.CustomerAdmin && user.role != roleName.CustomerCoordinator">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Origin</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7
                                  placeholder="Origin"
                                  [settings]="originSetting"
                                  [data]="serviceOriginLocations"
                                  [(ngModel)]="memberPreferenceSettings.origin">
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2" *ngIf="user.role == roleName.ExecutiveAdmin||user.role==roleName.Coordinator||
                    user.role==roleName.Accounting || user.role==roleName.Management">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Vendor</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <div class="select-box" *ngIf="vendorList?.length > 0">
                                <ng-multiselect-dropdown-angular7 [placeholder]="'Vendor'"
                                    [settings]="vendorListSetting" [data]="vendorList"
                                    [(ngModel)]="memberPreferenceSettings.vendor">
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2" *ngIf="user.role == roleName.ExecutiveAdmin||user.role==roleName.Coordinator||
                    user.role==roleName.Accounting || user.role==roleName.Management">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Driver</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7 [placeholder]="'Driver'"
                                    [settings]="driverListSetting" [data]="driverList"
                                    [(ngModel)]="memberPreferenceSettings.driver">
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2" *ngIf="user.role == roleName.ExecutiveAdmin||user.role==roleName.Coordinator||
                    user.role==roleName.Accounting || user.role==roleName.Management">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Assign Coordinator</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <div class="select-box">
                                <ng-multiselect-dropdown-angular7 [placeholder]="'Coordinator'"
                                    [settings]="coordinatorFilterSetting" [data]="coordinatorData"
                                    [(ngModel)]="memberPreferenceSettings.assignedCoordinator">
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">
                            <span>Time Zone</span><span class="text-danger"> * </span>
                        </div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <div class="select-box">
                                <ngx-select-dropdown [multiple]="false" name="timeZone" id="timeZoneDropDown"
                                    [config]="timezoneConfig" [options]="timeZoneList" style="width:98%;"
                                    [(ngModel)]="memberPreferenceSettings.selectedTimeZone"
                                    (ngModelChange)="isTimeZoneEmpty = false">
                                </ngx-select-dropdown>
                                <div *ngIf="isTimeZoneEmpty" class="invalid-feedback">
                                    <span class="text-danger">Select TimeZone</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">From Date</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <select class="form-control inline-block col-sm-3 pull-right"
                                [(ngModel)]="memberPreferenceSettings['fromDate']">
                                <option *ngFor="let filter of dateFilters" [value]="filter">{{filter}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row py-2">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">To Date</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <select class="form-control inline-block col-sm-3 pull-right"
                                [(ngModel)]="memberPreferenceSettings['toDate']">
                                <option *ngFor="let filter of toDateFilters" [value]="filter">{{filter}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row py-2" *ngIf="user.role == roleName.ExecutiveAdmin||user.role==roleName.Coordinator||
                    user.role==roleName.Accounting || user.role==roleName.Management">
                        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 mb-2">Job Type</div>
                        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 px-4 ">
                            <div class="select-box" *ngIf="transportTypeList && transportTypeList.length > 0">
                                <ng-multiselect-dropdown-angular7
                                  [placeholder]="'Job Type'"
                                  [settings]="transportTypeListSetting"
                                  [data]="transportTypeList"
                                  [(ngModel)]="memberPreferenceSettings.transportType">
                                </ng-multiselect-dropdown-angular7>
                            </div>
                        </div>
                    </div>
                  <div class="row py-2">
                    <div class="tbd-filter">
                      <label>
                        <span>Include TBD Pickup Time</span>
                        <input class="mt-0 checkbox" type="checkbox" id="tbd-checkbox" name="tbd-checkbox" [(ngModel)]="memberPreferenceSettings.includeTBD">
                      </label>
                    </div>
                  </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row px-3" style="display: flex; flex-direction:row-reverse">
                    <button type="button float-right" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                        (click)="saveMemberPreferenceSettings();loader=true;">Save</button>
                    <button type="button float-right"
                        class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10" data-dismiss="modal"
                        (click)="closePopup()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>
